module.exports = __webpack_public_path__ + "images/smartorg_logo_transparent.png";


//////////////////
// WEBPACK FOOTER
// ./app/views/password-reset/app/images/smartorg_logo_transparent.png
// module id = 64
// module chunks = 0